import { useContext, useEffect, useState } from "react";
import { useAuthUser } from "react-auth-kit";
import { buildGetOptions, buildPostOptions, fetchWithErrorHandling } from "services/FetchUtils";
import { AppContext } from "utils/AppContext";
import { getBaseURL, isRunningLocally } from "utils/Environment";
import { IDataEntity } from "./DataSchemaService";
import { getUserInfo } from "services/aws/CognitoService";

export const listLiveOperationsByEnvironment = async (accessToken: string, baseURL: string, environment: string) => {
  return fetchWithErrorHandling(
    baseURL + `v1/customer-support/live-operations/env/${environment}`,
    buildGetOptions(accessToken),
  );
};

export const updatePlayerData = async (
  accessToken: string,
  baseURL: string,
  userEmail: string,
  playerId: string,
  dataEntityType: string,
  data: IDataEntity,
) => {
  return fetchWithErrorHandling(
    baseURL + `v1/customer-support/update-player-data`,
    buildPostOptions(accessToken, { userEmail, playerId, dataEntityType, data }),
  );
};

export const useCustomerSupportService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;
  const appContext = useContext(AppContext);
  const [userEmail, setUserEmail] = useState("unknown@fortis.com");
  useEffect(() => {
    (async () => {
      if (!isRunningLocally()) {
        try {
          const fetchedUserInfo = await getUserInfo(accessToken);
          if (fetchedUserInfo.email) {
            setUserEmail(fetchedUserInfo.email);
          }
        } catch {
          // ignore
        }
      }
    })();
  }, [accessToken]);

  return {
    listLiveOperationsByEnvironment: (environment: string) =>
      listLiveOperationsByEnvironment(accessToken, getBaseURL(appContext), environment),
    updatePlayerData: (playerId: string, dataEntityType: string, data: IDataEntity) =>
      updatePlayerData(accessToken, getBaseURL(appContext), userEmail, playerId, dataEntityType, data),
  };
};
